import { Autocomplete, AutocompleteProps } from '../../Autocomplete';
import { FormFieldProps } from '../types';
import { splitProps } from '@/utils';
import { Field, useField } from '../Field';
import { AutocompleteItem } from '@/components';
import { useFormContext } from 'react-hook-form';
import { useCallback } from 'react';

export const splitPropsList = [
  'className',
  'disabled',
  'items',
  'getOptionValue',
  'getOptionLabel',
];

export const AutocompleteComponent = (props: AutocompleteProps) => {
  const field = useField();
  const { setValue } = useFormContext();

  const handleChange = useCallback(
    (value: AutocompleteItem) => {
      setValue(field.name, value, { shouldDirty: true, shouldValidate: true });
    },
    [setValue, field.name],
  );

  return <Autocomplete {...{ ...props, ...field, onChange: handleChange }} />;
};

export const AutocompleteField = (fieldProps: FormFieldProps<AutocompleteProps>) => {
  const restProps = splitProps(fieldProps, splitPropsList) as AutocompleteProps;

  return (
    <Field {...fieldProps}>
      <AutocompleteComponent {...restProps} />
    </Field>
  );
};
